import React from 'react'
import { Link } from "react-router-dom"
import CardUI from '../../../../widgets/layout/CardUI'
import ButtonUI from '../../../../widgets/action/ButtonUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import ErrorMessage2UI from '../../../../widgets/form/ErrorMessage2UI'
import SuccessMessageUI from '../../../../widgets/form/SuccessMessageUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import FileUploadModalSF from '../../../../widgets/form/FileUploadModalSF'
import ButtonWithSpinnerUI from '../../../../widgets/action/ButtonWithSpinnerUI'
import AccountRemarksModalSF from '../../account/util/AccountRemarksModalSF'
import LinkWithSpinnerUI from '../../../../widgets/action/LinkWithSpinnerUI'
import RemarksModalSF from './RemarksModalSF'
import './LoanFeasibility.css'

const LoanFeasibilityUI = ({ context, loan, loanFeasibility, feasibilityItemList, onRefreshClick,
  onIntRemClk, internalRemarksMode, onCancelRemarksClick, objectId, selectedRemarks,
  onExtRemClk, externalRemarksMode,
  toggleEditable, editable,
  showEmail, onShowEmail, onHideEmail, onSendEmail, sendingEmail, emailSuccessMsg, emailErrorList,
  onSendInternalEmail, sendingInternalEmail, fileUploadMode, onFileUploadClick, onfileUploadCancel, onfileUpload, signedUrlApi,
  onFileDownloadClick
}) =>
  <div className='c_l_fs'>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Feasibility</b></span>
        </div>
      }
      right={
        <span />
      }
    />

    {
      showEmail &&
      <div>
        <SuccessMessageUI successMsg={emailSuccessMsg} />
        <ErrorMessage2UI errorList={emailErrorList} />
        <div className='g_flex_h g_flex_right'>
          <ButtonWithSpinnerUI label='Send Email' onClick={onSendEmail} busy={sendingEmail} disabled={sendingEmail} />
          <ButtonUI label='Cancel' onClick={onHideEmail} transparent={true} />
        </div>
        <EmailUI loanFeasibility={loanFeasibility} />
      </div>
    }

    <div className='g_flex_h g_flex_right g_m_top_50'>
      {
        !showEmail &&
        <Link to='#' onClick={onShowEmail}>Preview email for client</Link>
      }
      <LinkWithSpinnerUI className='g_m_left_50' label='Internal email' spinnerOnLeft={true}
        onClick={onSendInternalEmail} busy={sendingInternalEmail}
      />
      <Link to='#' onClick={toggleEditable} className='g_m_left_100'>Details</Link>
    </div>

    <LRTableBodyUI className='g_m_top_100'>
      {
        feasibilityItemList.filter(item => item.flavor === 'classic').map((item, i) =>
          <RowUI key={i} context={context} item={item} onIntRemClk={onIntRemClk} onExtRemClk={onExtRemClk} onFileUploadClick={onFileUploadClick} onFileDownloadClick={onFileDownloadClick} editable={editable} />
        )
      }
    </LRTableBodyUI>

    <h3 className='g_m_top_200'>Loan feasibility for Small Loan</h3>
    <LRTableBodyUI>
      {
        feasibilityItemList.filter(item => item.flavor === 'small').map((item, i) =>
          <RowUI key={i} context={context} item={item} onIntRemClk={onIntRemClk} onExtRemClk={onExtRemClk} onFileUploadClick={onFileUploadClick} onFileDownloadClick={onFileDownloadClick} editable={editable} />
        )
      }
    </LRTableBodyUI>

    <RemarksModalSF context={context} account={loan.account}
      updateMode={internalRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} objectCode='loan_feasibility' objectId={objectId}
      selectedRemarks={selectedRemarks}
    />

    <AccountRemarksModalSF context={context} account={loan.account}
      updateMode={externalRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} objectCode='loan_feasibility_ext' objectId={objectId}
      remarksLabel='Automated remarks for client'
      selectedRemarks={selectedRemarks}
    />

    <FileUploadModalSF
      context={context}
      uploadMode={fileUploadMode}
      onCancelClick={onfileUploadCancel}
      signedUrlApi={signedUrlApi}
      onUpload={onfileUpload}
    />

    <div className='g_m_top_100'><b>Dirctor CIBIL scores</b></div>
    <table><tbody>
      {
        loanFeasibility.cibilDataList && loanFeasibility.cibilDataList.map((data, i) =>
          <tr key={i}>
            <td>{data.dinName}</td>
            <td>{data.dinNumber}</td>
            <td>{data.cibilScore}</td>
          </tr>
        )
      }
    </tbody></table>

    <div className='g_m_top_100'><b>GST filing</b></div>
    <table className='g_table g_m_top_50'>
      <thead className='g_sticky'>
        <tr>
          <td><b>GST number</b></td>
          <td><b>GST R1</b></td>
          <td><b>GST R2A</b></td>
          <td><b>GST R3B</b></td>
          <td><b>Last available</b></td>
        </tr>
      </thead>
      <tbody>
        {
          loanFeasibility.gstDataList && loanFeasibility.gstDataList.map((data, i) =>
            <tr key={i}>
              <td>{data.gstinNumber}</td>
              <td>{data.gstR1}</td>
              <td>{data.gstR2A}</td>
              <td>{data.gstR3B}</td>
              <td>{data.lastMonthYear}</td>
            </tr>
          )
        }
      </tbody>
    </table>

    <div className='g_m_top_100'><b>Ending cash</b></div>
    <table><tbody>
      {
        loanFeasibility.endingCashList && loanFeasibility.endingCashList.map((data, i) =>
          <tr key={i}>
            <td>{data.accountNumber}</td>
            <td>{data.monthYear}</td>
          </tr>
        )
      }
    </tbody></table>
  </div>

const EmailUI = ({ loanFeasibility }) =>
  <CardUI className='g_m_top_100 g_m_bottom_100' title='Subject: Information requested'>
    <span dangerouslySetInnerHTML={{ __html: loanFeasibility.clientEmailBody }} />
  </CardUI>

const RowUI = ({ context, item, onIntRemClk, onExtRemClk, onFileUploadClick, onFileDownloadClick, editable }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} item={item}
      onIntRemClk={onIntRemClk} onExtRemClk={onExtRemClk} onFileUploadClick={onFileUploadClick} onFileDownloadClick={onFileDownloadClick}
      editable={editable}
    />}
    right={
      <RowRightUI item={item} />
    }
  />

const RowLeftUI = ({ context, item, onIntRemClk, onExtRemClk, editable }) =>
  <div className='g_flex_h g_flex_top'>
    <span>{item.id}</span>
    <div className='g_flex_v g_m_left_100'>
      <span>
        <span>{item.itemName}</span>
        {
          !item.internalRemarks && editable &&
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_ultra_muted" onClick={onIntRemClk}
            data-object-id={item.code}></span>
        }
        {
          !item.externalRemarks && editable && context.permissions.includes('su_superuser_business') &&
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_ultra_muted" onClick={onExtRemClk}
            data-object-id={item.code}></span>
        }
        {
          editable &&
          <>
            {/* <Link to="#" className="g_m_left_100" onClick={onFileUploadClick} data-object-id={name}>Upload image</Link> */}
            {/* <Link to="#" className="g_m_left_100" onClick={onFileDownloadClick} data-object-id={name} data-date={""}>Download</Link> */}
          </>
        }
      </span>
      {/*
        editable && (!item.formulaList || !item.formulaList.length) &&
        <span className='g_muted'>
          {list[name + 'Check']}
        </span>
      */}
      {
        editable && item.formulaList && item.formulaList.length > 0 &&
        <table className='g_small frml'><tbody>
          {
            item.formulaList.map((row, i) =>
              <tr key={i} className={row.total ? 'g_h3' : ''}>
                <td className={`frml_l ${row.highLight ? 'g_warn' : ''}`}>{row.label}</td>
                <td className={`frml_r g_text_right ${row.highLight ? 'g_warn' : ''}`}>{row.value ? row.value : ''}</td>
              </tr>
            )
          }
        </tbody></table>
      }
      {
        item.recommendation &&
        <span className='g_success g_small'>
          <b>Console recommendation: </b>
          <span dangerouslySetInnerHTML={{ __html: item.recommendation }} />
        </span>
      }
      {
        editable && item.externalRemarks &&
        <span className='g_flex_h g_flex_left'>
          <span className='g_info2 g_small'><b>Automated remarks for client:</b> {item.externalRemarks}</span>
          {
            editable && context.permissions.includes('su_superuser_business') &&
            <span className='icon icon-pencil g_m_left_50 g_cursor_pointer g_ultra_muted' onClick={onExtRemClk}
              data-object-id={item.code}></span>
          }
        </span>
      }
      {
        item.internalRemarks &&
        <span className='g_flex_h g_flex_left'>
          <span className='g_info g_small'><b>Remarks by underwriter:</b> {item.internalRemarks}</span>
          {
            editable &&
            <span className='icon icon-pencil g_m_left_50 g_cursor_pointer g_ultra_muted' onClick={onIntRemClk}
              data-object-id={item.code}></span>
          }
        </span>
      }
    </div>
  </div>

const RowRightUI = ({ item }) =>
  <span className='g_m_left_100'>
    {item.insufficientData && <span className='icon icon-question'></span>}
    {!item.insufficientData && item.pass && <span className='icon icon-check'></span>}
    {!item.insufficientData && !item.pass && <span className='icon icon-times'></span>}
  </span>

export default LoanFeasibilityUI
